import SearchBar from './searchBar';

export default SearchBar;